module.exports = __webpack_public_path__ + "static/media/ic-1.1c5b78fd.svg";